module.exports = __webpack_public_path__ + "static/images/fa-light-300.761211f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-light-300.svg
// module id = 7gbC
// module chunks = 13 14